export const ERROR_PAGES_TEXTS = {
  NO_RESULT_FOUND_WITH_FILTERS: {
    title: 'No result Found',
    subtitle: `Sorry, we couldn't find any products matching your filters`,
    buttonText: 'Reset Filters',
    imgSrc: 'https://images-static.nykaa.com/fashion-images/error404.svg',
    errorMessage: 'noResultFoundWithFilters',
  },
  NO_RESULT_FOUND: {
    title: 'No Result Found',
    subtitle: `Sorry, we couldn't find any products`,
    buttonText: 'Back to Home',
    imgSrc: 'https://images-static.nykaa.com/fashion-images/error404.svg',
    errorMessage: 'noResultFound',
  },
  SOMETHING_WENT_WRONG: {
    title: 'Something Went Wrong',
    subtitle: `Whoops! Something seems broken here. Come back later & try again.`,
    buttonText: 'Back to Home',
    imgSrc:
      'https://images-static.nykaa.com/nykdesignstudio-images/pub/media/something_went_wrong.svg',
    errorMessage: '500',
  },
  SEARCH_AGAIN: (searchText: string) => {
    return {
      title: 'Uh Oh.',
      subtitle: `We’re sorry, we looked but couldn’t find any results for “${searchText}”.`,
      imgSrc: 'https://images-static.nykaa.com/fashion-images/error404.svg',
      errorMessage: 'searchPage',
    };
  },
  PAGE_404: {
    title: '404 Error',
    subtitle: `Oops! We couldn’t find the page you are looking for`,
    buttonText: 'Back to Home',
    imgSrc:
      'https://images-static.nykaa.com/nykdesignstudio-images/pub/media/something_went_wrong.svg',
    errorMessage: '404',
  },
  PAGE_NOT_FOUND: {
    title: 'Page Not Found',
    subtitle: `Oops! We couldn’t find the page you are looking for`,
    buttonText: 'Back to Home',
    imgSrc:
      'https://images-static.nykaa.com/nykdesignstudio-images/pub/media/something_went_wrong.svg',
    errorMessage: 'pageNotFound',
  },
};
